let scrollListener = null;
let $scrollEl = null;        // element we attached the scroll listener to
let scrollIsWindow = false;  // true → host page scrolls (inline embed)
let $jq = null;              // jQuery ref (needed in destroy)

export function initCategoryScrollSync({ rootContainer, $ }) {
  $jq = $;
  const $holder = rootContainer.find('.booking-steps-holder');
  const holderEl = $holder[0];
  const $list  = $('.step-multiple-categories-list', $holder);
  const $items = $('li a', $list);
  const $titles = $('.step-category-title', $holder);

  // Where does scrolling actually happen?
  //  - Popup / fullscreen embeds: `.booking-steps-holder` has a bounded height
  //    and scrolls internally.
  //  - Inline embeds (e.g. the widget dropped into a WordPress/Elementor page)
  //    have no bounded height, so the holder's content never overflows
  //    (scrollHeight == clientHeight) and animating its scrollTop is a no-op —
  //    the HOST PAGE scrolls instead. Detect that and drive the window.
  // Re-checked on each click too, so a wrong guess at init time can't break it.
  const holderScrolls = (el) => !!el && el.scrollHeight > el.clientHeight + 2;
  scrollIsWindow = !holderScrolls(holderEl);
  $scrollEl = scrollIsWindow ? $(document.scrollingElement || document.documentElement) : $holder;

  // Holder mode aligns the target to where the first title sits; window mode
  // leaves a small gap so the title isn't glued under any sticky header.
  const firstTitleTop = $titles.length > 0 ? $titles.first().position().top : 0;
  const WINDOW_TOP_GAP = 80;

  // Activate first category item
  $items.first().addClass('active');

  // Click on a category → scroll the correct container to its service group.
  $list.on('click', 'a', function (e) {
    e.preventDefault();
    const targetId = $(this).attr('href').substring(1);
    const $target = $holder.find('#' + targetId);  // scoped find
    if (!$target.length) return;

    if (holderScrolls(holderEl)) {
      // .position() shrinks by the holder's current scroll (offset parent is
      // the holder), so it was only correct on the first click, when scroll
      // was still 0 — every later click landed short by the scrolled amount.
      // offset() delta + current scrollTop is scroll-independent.
      const targetTop = $holder.scrollTop() + $target.offset().top - $holder.offset().top;
      $holder.animate({
        scrollTop: targetTop - firstTitleTop
      }, 300, 'linear');
    } else {
      // Inline embed — scroll the page to the target's absolute position.
      $('html, body').animate({
        scrollTop: $target.offset().top - WINDOW_TOP_GAP
      }, 300, 'linear');
    }
  });

  // Arrows
  const $prev = $('.step-categories-slider-prev', $holder);
  const $next = $('.step-categories-slider-next', $holder);

  const animateSlide = (dist) => {
    $list.animate({ scrollLeft: $list.scrollLeft() + dist }, 200);
  };

  $next.on('click', () => animateSlide(200));
  $prev.on('click', () => animateSlide(-200));

  // Hide arrows if no scroll overflow
  setTimeout(() => {
    if ($list[0]?.scrollWidth <= $list[0]?.clientWidth) {
      $prev.hide();
      $next.hide();
    }
  }, 0);

  // Active tab follows scroll
  const slideToItem = (item) => {
    const listOffset = $list.offset().left;
    const itemOffset = $(item).offset().left;
    const currentScroll = $list.scrollLeft();
    $list.animate({ scrollLeft: currentScroll + itemOffset - listOffset }, 0);
  };

  const updateActiveCategory = () => {
    let last = null;

    if (scrollIsWindow) {
      // Page-scroll: compare each title's absolute top to the viewport line.
      const viewLine = $(window).scrollTop() + WINDOW_TOP_GAP + 1;
      $titles.each(function () {
        if ($(this).offset().top <= viewLine) last = this;
      });
    } else {
      // Holder-scroll: a category is "current" once its title has crossed the
      // line where clicked titles land (firstTitleTop below the holder's top
      // edge, +1px tolerance like the window branch). Same coordinate system
      // as the click handler, so clicking a pill always highlights that pill.
      // The old wrapper/position() math mixed origins and needed the first
      // title to sit within 81px of the step top — never true, so the
      // previous category stayed highlighted after every click.
      const holderTop = $holder.offset().top;
      const scrollTop = $holder.scrollTop();
      const containerHeight = holderEl.scrollHeight - holderEl.clientHeight;

      $titles.each(function () {
        if (!$(this).is(':visible')) return;
        if ($(this).offset().top - holderTop <= firstTitleTop + 1) last = this;
      });
      if (scrollTop >= containerHeight - 20) {
        last = $titles.last()[0];
      }
    }

    if (!last) last = $titles.first()[0];

    if (last) {
      const id = last.id;
      const $item = $items.filter(`[href="#${id}"]`);
      $items.removeClass('active');
      $item.addClass('active');
      slideToItem($item);
    }
  };

  const debounce = (fn, delay = 100) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  };

  scrollListener = debounce(updateActiveCategory);
  if (scrollIsWindow) {
    $(window).on('scroll', scrollListener);
  } else {
    $holder.on('scroll', scrollListener);
  }
}

export function destroyCategoryScrollSync() {
  if (scrollListener) {
    if (scrollIsWindow) {
      ($jq || jQuery)(window).off('scroll', scrollListener);
    } else if ($scrollEl) {
      $scrollEl.off('scroll', scrollListener);
    }
    scrollListener = null;
    $scrollEl = null;
  }
}
